import {firebaseUatConfig, firebaseProdConfig} from "firebase/firebaseConfig";
enum Env {
    LOCAL = "LOCAL",
    UAT = "UAT",
    PROD = "PROD",
}

const LamHosts = {
    [Env.UAT]: "https://uatapi.datasignstech.com:8443/loanAminute",
    [Env.PROD]: "https://api.datasignstech.com:8443/loanAminute",
    [Env.LOCAL]: "http://localhost:8080/loanAminute",
};
const gatewayHosts = {
    [Env.UAT]: "https://uat-gateway.datasignstech.com",
    [Env.PROD]: "https://gateway.datasignstech.com",
};
const insuranceHosts = {
    [Env.UAT]: "https://uat-gateway.datasignstech.com/insurance-gateway",
    [Env.PROD]: "https://gateway.datasignstech.com/insurance-gateway",
};
const ImageBaseUrl = {
    [Env.UAT]: "https://www.myshubhlife.com",
    [Env.PROD]: "https://www.myshubhlife.com",
    [Env.LOCAL]: "https://www.myshubhlife.com",
};
const WebsiteUrl = {
    [Env.UAT]: "https://uat.myshubhlife.com",
    [Env.PROD]: "https://www.myshubhlife.com",
    [Env.LOCAL]: "https://uat.myshubhlife.com",
};
const LamEnv = {
    [Env.UAT]: "uat",
    [Env.PROD]: "prod",
    [Env.LOCAL]: "local",
};

const ApplyUrl = {
    [Env.UAT]: "https://uat.myshubhlife.com/apply/",
    [Env.PROD]: "https://www.myshubhlife.com/apply/",
    [Env.LOCAL]: "https://uat.myshubhlife.com/apply/",
};

const AndroidAppPackage = {
    [Env.UAT]: "com.datasignstech.lam.dev",
    [Env.PROD]: "com.datasignstech.lam",
    [Env.LOCAL]: "com.datasignstech.lam.dev",
};

const DynamicLinkUrlPrefix = {
    [Env.UAT]: "https://bhe8x.app.goo.gl/",
    [Env.PROD]: "https://shbln.page.link/",
    [Env.LOCAL]: "https://bhe8x.app.goo.gl/",
};

const FirebaseApiKey = {
    [Env.UAT]: "AIzaSyCAdf80Difn-TpLqksA3klK2magVm_Ck6k",
    [Env.PROD]: "AIzaSyBmOEPV2mydScdNB-1saB3F-KjIUg5FOas",
    [Env.LOCAL]: "AIzaSyCAdf80Difn-TpLqksA3klK2magVm_Ck6k",
};
const BranchApiKey = {
    [Env.UAT]: "key_test_giUQPuHOwLizPc8T991URlonyymnr6n2",
    [Env.LOCAL]: "key_test_giUQPuHOwLizPc8T991URlonyymnr6n2",
    [Env.PROD]: "key_live_bdRLJzGRrOeANa8K424Iolddwzoaw2gP",
};
const MedullaHosts = {
    [Env.UAT]: "https://uat-medulla.datasignstech.com:9443",
    [Env.LOCAL]: "http://localhost:9000",
    [Env.PROD]: "https://medulla.datasignstech.com:9443",
};

const ConsentAndroidRedirect = {
    [Env.UAT]: "https://uat.myshubhlife.com/apply/#/android/consent/redirection",
    [Env.LOCAL]: "http://localhost:3000/apply/#/android/consent/redirection",
    [Env.PROD]: "https://www.myshubhlife.com/apply/#/android/consent/redirection",
};

const ConsentWebAppRedirect = {
    [Env.UAT]: "https://uat.myshubhlife.com/apply/#/consent/redirection",
    [Env.LOCAL]: "http://localhost:3000/apply/#/consent/redirection",
    [Env.PROD]: "https://www.myshubhlife.com/apply/#/consent/redirection",
};

const ShubhSignHosts = {
    [Env.UAT]: "https://uat-gateway.datasignstech.com/shubhsign",
    [Env.LOCAL]: "http://localhost:8083",
    [Env.PROD]: "https://gateway.datasignstech.com/shubhsign",
};

const Hagen = {
    [Env.UAT]: "https://uat-gateway.datasignstech.com/hagen",
    [Env.PROD]: "https://gateway.datasignstech.com/hagen",
};

const DMIOkycEndPages = {
    [Env.UAT]: "https://okyc.dmifinance.in/EcsOkycWeb/RequestTrace.jsp",
    [Env.LOCAL]: "https://okyc.dmifinance.in/EcsOkycWeb/RequestTrace.jsp",
    [Env.PROD]: "https://okycprod.dmifinance.in/EcsOkycWeb/RequestTrace.jsp",
};

export const ifscVerifyLink = `https://ifsc.razorpay.com`;

const xApi = {
    [Env.UAT]: "8eedccfb6e614f1393de0c9c5b683073",
    [Env.PROD]: "eef631b7ccd3a113886d82b0e20ecb0e",
};

const FirebaseConfig = {
   [Env.UAT]: firebaseUatConfig,
   [Env.PROD]: firebaseProdConfig,
}

const RazorPayKey = {
    [Env.UAT]: "rzp_test_33rn0qKSn7xray",
    [Env.PROD]: "rzp_live_UvcTmFCG0c3Efv",
}
const GoogleScript = {
    [Env.PROD]: "https://accounts.google.com/gsi/client",
    [Env.UAT]: "https://accounts.google.com/gsi/client",
};
const GoogleClientId = {
    [Env.PROD]: "734320453531-tn2geg5uk2dvktdh90ud2lbifk1pr2fh.apps.googleusercontent.com",
    [Env.UAT]: "1077214603431-k0gs7k9ot0cn0hgrjl2gpikcifp83msf.apps.googleusercontent.com",
};
const GoogleLoginVersion = {
    [Env.PROD]: "V2",
    [Env.UAT]: "V2",
};

const NachRazorpayRedirectionUrl = {
    [Env.PROD]: "https://gateway.datasignstech.com/nach-gateway/razorpay-redirect",
    [Env.UAT]: "https://uat-gateway.datasignstech.com/nach-gateway/razorpay-redirect",
};

const WebEngageKey = {
    [Env.UAT]: "in~826172c6",
    [Env.PROD]: "in~14507c767",
};

const env: Env = Env[(window as any).SL_ENV] || Env[process.env.API_ENV];
export const baseUrl = LamHosts[env];
export const envLam = LamEnv[env];
export const imageBaseUrl = ImageBaseUrl[env];
export const applyUrl = ApplyUrl[env];
export const androidAppPackage = AndroidAppPackage[env];
export const dynamicLinkUrlPrefix = DynamicLinkUrlPrefix[env];
export const firebaseApiKey = FirebaseApiKey[env];
export const gatewayUrl = gatewayHosts[env];
export const branchApiKey = BranchApiKey[env];
export const insuranceUrl = insuranceHosts[env];
export const medullaUrl = MedullaHosts[env];
export const consentAndroidRedirect = ConsentAndroidRedirect[env];
export const consentWebAppRedirect = ConsentWebAppRedirect[env];
export const shubhSignUrl = ShubhSignHosts[env];
export const dmiOkycEndPage = DMIOkycEndPages[env];
export const websiteUrl = WebsiteUrl[env];
export const firebaseConfig = FirebaseConfig[env];
export const xApiKey = xApi[env];
export const googleClientId = GoogleClientId[env];
export const googleLoginVersion = GoogleLoginVersion[env];
export const googleScript = GoogleScript[env];
export const razorpayKey = RazorPayKey[env];
export const nachRazorpayRedirectionUrl = NachRazorpayRedirectionUrl[env];
export const hagenUrl = Hagen[env];
export const webEngageKey = WebEngageKey[env];
